import React from 'react';
import Header from "../../../../components/layout/headers/Header";
import Sidebar from '../../../../components/layout/navigation/sidebar/DynamicSidebar';
import DeviceReportsTable from './DeviceReportsTable';

const DeviceReports = () => {
    return (
        <>
            <Header/>
            <Sidebar/>
            <div className="content-body">
                <div className="w-full px-4">
                    <DeviceReportsTable/>
                </div>
            </div>
        </>
    );
}

export default DeviceReports;
